module.exports = __webpack_public_path__ + "img/guide-student8.0fd2828b.png";